export default "__VITE_ASSET__DGmqoA30__"